import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { StepComponent } from '@app/components';
import { AnalyticEvents } from '@app/enums';
import { RoutingStateService } from '@app/modules/common/services/routing-state.service';
import { getSelectedParticipants } from '@app/modules/performance/functions';
import { AnalyticService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { NotifyService } from '@app/services/notify.service';
import { StoreView } from '@common/views';
import { Goal } from '@models/performance/goal.model';

@Component({
    templateUrl: './goal-store.template.html',
    styleUrls: ['./goal-store.style.scss'],
})
export class GoalStoreView extends StoreView {
    goal: Goal;

    isLoading = false;

    participants: Map<number, boolean> = new Map<number, boolean>();

    constructor(
        public auth: AuthService,
        private location: Location,
        private notify: NotifyService,
        private routingState: RoutingStateService,
        private analyticService: AnalyticService
    ) {
        super();
        this.goal = new Goal({
            reoccuring: 'never',
            is_shared: true,
            metric_type: 'percent',
            metric_value: 100,
        });
    }

    onSave(): void {
        this.isLoading = true;

        this.goal
            .attach('participants', getSelectedParticipants(this.participants))
            .save()
            .then(() => {
                this.notify.success('performance.goal-store.goalCreatedMessage');
                if (this.routingState.previousUrl?.includes('overview')) {
                    this.analyticService.trackEvent(AnalyticEvents.PerformanceOverviewCreateGoalClickCompleteToSave);
                }
                if (this.routingState.previousUrl?.includes('goals')) {
                    this.analyticService.trackEvent(AnalyticEvents.PerformanceGoalsCreateGoalClickCompleteToSave);
                }
                if (this.routingState.previousUrl?.includes('employees')) {
                    this.analyticService.trackEvent(
                        AnalyticEvents.EmployeeProfilePerformanceCreateGoalsClickCompleteToSave
                    );
                }

                if (this.goal.isShared) {
                    this.analyticService.trackEvent(AnalyticEvents.PerformanceAllPathstoCreateGoalTypeSelectSharedGoal);
                } else {
                    this.analyticService.trackEvent(
                        AnalyticEvents.PerformanceAllPathsToCreateGoalTypeSelectPerEmployee
                    );
                }

                this.location.back();
            })
            .catch(() => this.notify.error('performance.goal-store.couldNotCreateGoalMessage'));
    }

    async onNextStep([currentStep]: [StepComponent, number]): Promise<void> {
        switch (currentStep.step) {
            case 'Metrics':
                this.analyticService.trackEvent(AnalyticEvents.PerformanceAllPathsToCreateGoalStep1ClickNext);
                break;
            case 'Participants':
                this.analyticService.trackEvent(AnalyticEvents.PerformanceAllPathsToCreateGoalStep2ClickNext);
                break;
            case 'Summary':
                this.analyticService.trackEvent(AnalyticEvents.PerformanceAllPathsToCreateGoalStep3ClickNext);
                break;
        }
    }

    async onPreviousStep([currentStep]: [StepComponent, number]): Promise<void> {
        switch (currentStep.step) {
            case 'New Goal':
                this.analyticService.trackEvent(AnalyticEvents.PerformanceAllPathsToCreateGoalStep2ClickPrevious);
                break;
            case 'Metrics':
                this.analyticService.trackEvent(AnalyticEvents.PerformanceAllPathsToCreateGoalStep3ClickPrevious);
                break;
            case 'Participants':
                this.analyticService.trackEvent(AnalyticEvents.PerformanceAllPathsToCreateGoalStep4ClickPrevious);
                break;
        }
    }
}
